import {createAction, props} from '@ngrx/store';
import {Uszkodzenie, ZbiorUszkodzen} from './zbiorUszkodzen';

export enum ZbiorUszkodzenActionTypes {
  AKTUALIZUJ_ZBIOR_USZKODZEN = '[ZbiorUszkodzen] aktualizuj',
  USUN_ZBIOR_USZKODZEN = '[ZbiorUszkodzen] usun',
  AKTUALIZUJ_USZKODZENIE = '[Uszkodzenie] aktualizuj',
  USUN_USZKODZENIE = '[Uszkodzenie] usun',
}

export const aktualizujZbiorUszkodzen = createAction(
  ZbiorUszkodzenActionTypes.AKTUALIZUJ_ZBIOR_USZKODZEN,
  props<{przedmiotId: number, zbiorUszkodzen: ZbiorUszkodzen }>()
);

export const usunZbiorUszkodzen = createAction(
  ZbiorUszkodzenActionTypes.USUN_ZBIOR_USZKODZEN,
  props<{przedmiotId: number, id: string }>()
);

export const aktualizujUszkodzenie = createAction(
  ZbiorUszkodzenActionTypes.AKTUALIZUJ_USZKODZENIE,
  props<{id: string, uszkodzenie: Uszkodzenie<any>}>()
);

export const usunUszkodzenie = createAction(
  ZbiorUszkodzenActionTypes.USUN_USZKODZENIE,
  props<{przedmiotId: number, id: string, uszkodzenieId: string}>()
);

